import AllStressors from "../../components/Stressors/AllStressors";

function Stressors(){
    return (
        <main>
        < AllStressors />
        </main>
    )


}

export default Stressors;